import { useSnackbar } from 'notistack'
import { useCallback, useEffect, useState } from 'react'
import { AspenDashboardService, ReferrerAggregationItem } from '../client'
import { CancelablePromise } from '../client/core/CancelablePromise'

export const useReferrerAggregation = () => {
    const [items, setItems] = useState<ReferrerAggregationItem[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)
    const { enqueueSnackbar } = useSnackbar()

    const fetchReferrerAggregation = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const response: CancelablePromise<ReferrerAggregationItem[]> =
                AspenDashboardService.getReferrerAggregationDashboardReferrerAggregationGet()
            const data = await response
            setItems(data)
        } catch (err) {
            setError('Failed to fetch referrer aggregation')
            enqueueSnackbar('Failed to fetch referrer aggregation', {
                variant: 'error'
            })
        } finally {
            setLoading(false)
        }
    }, [enqueueSnackbar])

    useEffect(() => {
        fetchReferrerAggregation()
    }, [fetchReferrerAggregation])

    return { items, loading, error, fetchReferrerAggregation }
}
